<template>
  <div class="main-wrapper">
    <div class="error-box">
      <div class="error-body text-center">
        <h1 class="error-title text-primary">{{ $t("404") }}</h1>
        <h3 class="text-uppercase error-subtitle">
          {{ $t("page-not-found") }}!
        </h3>
        <p class="text-muted m-t-30 m-b-30">
          {{ $t("trying-to-find-way-home") }}
        </p>
        <router-link
          to="/login"
          class="btn btn-primary btn-rounded waves-effect waves-light m-b-40"
          >{{ $t("back-to-home") }}</router-link
        >
      </div>
    </div>
  </div>
</template>

<i18n>
{
	"en": {
		"404": "404",
		"back-to-home": "Back to home",
		"trying-to-find-way-home": "You seem to be trying to find your way home",
		"page-not-found": "PAGE NOT FOUND"
	},
	"fr": {
		"404": "404",
		"back-to-home": "Retour à la page d'accueil",
		"trying-to-find-way-home": "Vous semblez essayer de retrouver votre chemin vers la page d'accueil",
		"page-not-found": "PAGE NON TROUVÉE"
	},
	"sw": {
		"404": "404",
		"back-to-home": "Rudi nyumbani",
		"trying-to-find-way-home": "Inaonekana unajaribu kupata njia ya kurudi nyumbani",
		"page-not-found": "UKURASA HAUPATIKANI"
	}
}
</i18n>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "NotFound",
  computed:{
    ...mapGetters([
      "profile",
    ]),
  },
  mounted(){
    this.$i18n.locale = this.profile.language
  }
};
</script>
